import { DownloadService } from '@src/utility/download.service';
import DOMPurify from 'dompurify';
import { FAQ_LIST_LABELS, FAQ_COMMON_CONSTANTS } from '../constants';
import { FaqItem } from './types';

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

// Format data for display
export const formatFaqData = (data: FaqItem[]) => {
  return data.map((faq) => {
    const formattedDate = faq.LastUpdated ? formatDate(faq.LastUpdated) : null;
    return {
      id: faq.QuestionId,
      'Question Name': {
        name: faq.Question,
        link: FAQ_COMMON_CONSTANTS.LINK_TRUE,
        color: '#196ecf',
      },
      Category: {
        name: faq.CategorySource,
        link: FAQ_COMMON_CONSTANTS.LINK_FALSE,
      },
      'Last Updated': {
        name: formattedDate,
        link: FAQ_COMMON_CONSTANTS.LINK_FALSE,
      },
      'Last Edited By': {
        name: faq.LastEditedBy || FAQ_LIST_LABELS.FIELD_VALUE_NOT_AVAILABLE,
        link: FAQ_COMMON_CONSTANTS.LINK_FALSE,
      },
      originalData: faq,
    };
  });
};

export const exportData = (faqData: FaqItem[]) => {
  const sheets: Array<any> = [];
  const kCExporttitle = 'FAQ Documentation Manager';
  const formatedExportData = faqData.map((content, index) => {
    return {
      'Question Name': content.Question,
      Answer: DOMPurify.sanitize(content.Answer),
      'More Info': DOMPurify.sanitize(content.MoreInfo),
      Notes: DOMPurify.sanitize(content.Notes),
      'Available In': content.MetricAvailableIn,
      Category: content.CategorySource,
      'Last Updated': content.LastUpdated
        ? formatDate(content.LastUpdated)
        : '',
      'Last Edited By': content.LastEditedBy || '',
    };
  });
  sheets.push({ title: kCExporttitle, data: formatedExportData });
  DownloadService.download(
    { sheets },
    {
      fileFormat: '.xlsx',
      fileName: 'FAQ Documentation Manager',
      journeyName: 'Content Editor',
      metricName: 'FAQ Documentation Manager',
    }
  );
};

// Sorting helpers
export const getSortOrder = (a: any, b: any, sortOrder: number) => {
  if (a < b) return -sortOrder;
  if (a > b) return sortOrder;
  return 0;
};

export const nestedSort = (
  prop1: string,
  prop2: string | null = null,
  direction: 'ASC' | 'DSC' = 'ASC'
) => {
  return (e1: any, e2: any) => {
    let a = prop2 ? e1[prop1][prop2] : e1[prop1];
    let b = prop2 ? e2[prop1][prop2] : e2[prop1];
    const sortOrder = direction === 'ASC' ? 1 : -1;

    // Handle date sorting
    if (
      prop1 === FAQ_LIST_LABELS.HEADER_LAST_UPDATED &&
      e2[prop1].name !== null
    ) {
      a = new Date(a);
      b = new Date(b);
    }

    return getSortOrder(a, b, sortOrder);
  };
};
